<div class="portal-page-content">
  <h1>Welcome {{ userName }}</h1>
  @if (!loadedComplete) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  }
  <app-portal-in-progress-credential
    (loaded)="onLoadedComplete('inProgress')"
    [hidden]="!loadedComplete"
  ></app-portal-in-progress-credential>
  <portal-dashboard-credential
    (loadedComplete)="onLoadedComplete('credentials')"
    [hidden]="!loadedComplete"
  ></portal-dashboard-credential>
  <app-portal-dashboard-cta
    (loadedComplete)="onLoadedComplete('cta')"
    [hidden]="!loadedComplete"
  ></app-portal-dashboard-cta>
  <portal-tasks
    (loadedComplete)="onLoadedComplete('tasks')"
    [hidden]="!loadedComplete"
  ></portal-tasks>
</div>
